package com.essntl.features.paymentparameter.ui.addeditpaymentparameter

import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel

sealed interface AddEditPaymentParameterEvent {
    data class GetPaymentParameter(val id: String) : AddEditPaymentParameterEvent
    data class UpdatePaymentParameterFields(val paymentParameter: PaymentParameterModel) : AddEditPaymentParameterEvent
    data object AddPaymentParameter : AddEditPaymentParameterEvent
    data object EditPaymentParameter : AddEditPaymentParameterEvent
    data object ClearState : AddEditPaymentParameterEvent
}